import { isBranchConstrained } from "../../../../auth/sessionAccess.ts";
import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFormik } from "formik";

import { useAppSettings } from "../../../../hooks/useAppSettings.tsx";
import { Panel, PanelBody, PanelHeader } from "../../../panel/panel.jsx";
import Title from "../../../Title.tsx";
import Layout from "../../../Layout.tsx";
import { RootState } from "../../../../store/index.ts";
import {
  ReporteRelojChecadorDefaultValues,
} from "../../../../interfaces/formik/IReporteRelojChecador.ts";
import ReporteRelojChecadorForm from "../../../../forms/ReporteRelojChecadorForm.tsx";
import { readBranches } from "../../../../services/branch.service.ts";
import Branch from "../../../../models/Branch.ts";
import ReporteRelojChecadorSchema from "../../../../validation/schemas/ReporteRelojChecadorSchema.ts";
import TableDiasSinAsistencia from "./TableDiasSinAsistencia.tsx";
import { findScheduledWithoutCheck } from "../../../../services/assistanceCheck.service.ts";

const DiasSinAsistencia = () => {
  useAppSettings();
  const { id } = useParams();
  const { user } = useSelector((state: RootState) => state.auth);
  const [branchs, setBranchs] = useState([]);
  const [title, setTitle] = useState("Días sin asistencia");
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: ReporteRelojChecadorDefaultValues(),
    validationSchema: ReporteRelojChecadorSchema,
    onSubmit: async (values) => {
      setRecords([]);
      setLoading(true);
      try {
        const { branch, partner, start, end } = values;
        if (formik.values.branch !== -99) {
          const branch = branchs.find(
            (branch: Branch) =>
              Number(branch.id) === Number(formik.values.branch)
          ) as any;
          if (branch?.name) setTitle(`Días sin asistencia - ${branch?.name}`);
        }

        const data = await findScheduledWithoutCheck(branch, partner, start, end);
        setRecords(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchDependencies = async () => {
    const number =
      isBranchConstrained(user) ? Number(user.branchId) : Number(id);
    try {
      const branches = await readBranches();
      const branch = branches.find(
        (branch: Branch) => Number(branch.id) === number
      );
      setTitle(`Días sin asistencia - ${branch?.name}`);
      await formik.setFieldValue("branch", branch?.id);
      setBranchs(branches);
    } catch (error) {
      console.log(error);
    } finally {
    }
    setLoading(false);
  };

  useEffect(() => {
    if (user) {
      fetchDependencies();
    }
  }, [user]);

  useEffect(() => {
    formik.handleSubmit();
  }, [branchs, id]);

  return (
    <React.Fragment>
      <Layout loading={loading}>
        <Title
          baseTitle="Sucursales"
          basePath="/sucursales"
          activeTitle="Días sin asistencia"
          title={title}
        />

        <div className="card border-0 m-4 rounded">
          <Panel>
            <PanelHeader noButton={true} className="bg-azul">
              Formulario para el reporte
            </PanelHeader>
            <PanelBody>
              <ReporteRelojChecadorForm
                formik={formik}
                branches={branchs}
                disabled={isBranchConstrained(user)}
                handleDownload={() => {}}
              />
            </PanelBody>
          </Panel>
        </div>

        <div className="card border-0 m-4 rounded">
          <div className="tab-content p-3">
            <TableDiasSinAsistencia
              records={records}
              loading={loading}
              start={formik.values.start}
              end={formik.values.end}
            />
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default DiasSinAsistencia;

